"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.TextInput = void 0;

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _assertThisInitialized2 = _interopRequireDefault(require("@babel/runtime/helpers/assertThisInitialized"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _react = _interopRequireWildcard(require("react"));

var _Button = _interopRequireDefault(require("../Button"));

var _Error = _interopRequireDefault(require("@material-ui/icons/Error"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _TextField = _interopRequireDefault(require("@material-ui/core/TextField"));

var _Tooltip = _interopRequireDefault(require("../Tooltip"));

var _classnames = _interopRequireDefault(require("classnames"));

var _memoizationHelper = require("../Utilities/memoizationHelper");

var _styles = require("./styles");

var _styles2 = require("@material-ui/core/styles");

var _FormControl = _interopRequireDefault(require("../FormControl"));

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { (0, _defineProperty2.default)(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = (0, _getPrototypeOf2.default)(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = (0, _getPrototypeOf2.default)(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0, _possibleConstructorReturn2.default)(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

var ContentCopy = function ContentCopy(props) {
  return /*#__PURE__*/_react.default.createElement("svg", props, /*#__PURE__*/_react.default.createElement("path", {
    d: "M19 21H8V7h11m0-2H8a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h11a2 2 0 0 0 2-2V7a2 2 0 0 0-2-2m-3-4H4a2 2 0 0 0-2 2v14h2V3h12V1z"
  }));
};

ContentCopy.defaultProps = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "24",
  height: "24",
  viewBox: "0 0 24 24"
};

var TextInput = /*#__PURE__*/function (_Component) {
  (0, _inherits2.default)(TextInput, _Component);

  var _super = _createSuper(TextInput);

  function TextInput(props) {
    var _this;

    (0, _classCallCheck2.default)(this, TextInput);
    _this = _super.call(this, props);
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "focus", function () {
      _this.input.focus();
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "handleCopy", function () {
      _this.input.select();

      document.execCommand("copy");

      _this.input.blur();

      _this.setState({
        didCopy: true
      });

      setTimeout(function () {
        return _this.setState({
          didCopy: false
        });
      }, 5000);
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "addWrapperId", function () {
      if (_this.formControlRef.current && _this.formControlRef.current.labelNode && _this.formControlRef.current.labelNode.offsetParent && _this.props.id) {
        _this.formControlRef.current.labelNode.offsetParent.setAttribute("id", _this.props.id + "-wrapper");
      }
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "componentDidMount", function () {
      _this.addWrapperId();
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "componentDidUpdate", function () {
      _this.addWrapperId();
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "render", function () {
      var _this$props = _this.props,
          id = _this$props.id,
          label = _this$props.label,
          disabled = _this$props.disabled,
          error = _this$props.error,
          errorMessage = _this$props.errorMessage,
          required = _this$props.required,
          autoFocus = _this$props.autoFocus,
          placeholder = _this$props.placeholder,
          type = _this$props.type,
          helperText = _this$props.helperText,
          multiline = _this$props.multiline,
          rows = _this$props.rows,
          rowsMax = _this$props.rowsMax,
          onFocus = _this$props.onFocus,
          onChange = _this$props.onChange,
          onKeyDown = _this$props.onKeyDown,
          onKeyUp = _this$props.onKeyUp,
          onClick = _this$props.onClick,
          onBlur = _this$props.onBlur,
          value = _this$props.value,
          fullWidth = _this$props.fullWidth,
          labelProps = _this$props.labelProps,
          inputComponent = _this$props.inputComponent,
          inputProps = _this$props.inputProps,
          className = _this$props.className,
          variant = _this$props.variant,
          classes = _this$props.classes,
          endAdornment = _this$props.endAdornment,
          startAdornment = _this$props.startAdornment,
          maxLength = _this$props.maxLength,
          style = _this$props.style,
          autoComplete = _this$props.autoComplete,
          _inputRef = _this$props.inputRef,
          copy = _this$props.copy,
          margin = _this$props.margin,
          readOnly = _this$props.readOnly;

      var copyEndAdornment = /*#__PURE__*/_react.default.createElement(_Tooltip.default, {
        title: "Copied!",
        open: _this.state.didCopy
      }, /*#__PURE__*/_react.default.createElement(_Button.default, {
        type: "icon",
        onClick: _this.handleCopy
      }, /*#__PURE__*/_react.default.createElement(_Tooltip.default, {
        title: _this.state.didCopy ? "" : "Copy"
      }, /*#__PURE__*/_react.default.createElement("div", {
        className: classes.buttonTooltipFix
      }, /*#__PURE__*/_react.default.createElement(ContentCopy, {
        alt: "copy"
      })))));

      var appliedLabelProps = (0, _memoizationHelper.memoize)((0, _assertThisInitialized2.default)(_this), "appliedLabelProps", function () {
        return _objectSpread(_objectSpread({
          className: (0, _classnames.default)("prmbl-textInput-label", classes[variant + "Label"]),
          classes: {
            shrink: classes[variant + "ShrunkLabel"],
            error: classes.error
          }
        }, labelProps), {}, {
          id: "".concat(id, "-label")
        });
      }, [variant, labelProps, id]);
      var appliedInputProps = (0, _memoizationHelper.memoize)((0, _assertThisInitialized2.default)(_this), "appliedInputProps", function () {
        return {
          inputComponent: inputComponent,
          inputProps: _objectSpread({
            maxLength: maxLength,
            disabled: readOnly || disabled
          }, inputProps),
          inputRef: function inputRef(el) {
            _this.input = el;
            if (typeof _inputRef === "function") _inputRef(el);
          },
          className: (0, _classnames.default)("prmbl-textInput-input", classes[variant + "Input"], (0, _defineProperty2.default)({}, classes.customComponent, inputComponent)),
          endAdornment: copy ? copyEndAdornment : endAdornment,
          startAdornment: startAdornment,
          classes: {
            input: classes[variant + "InputElement"]
          },
          autoComplete: autoComplete
        };
      }, [inputComponent, inputProps, variant, endAdornment, startAdornment, autoComplete, copyEndAdornment]);

      var renderedErrorMessage = /*#__PURE__*/_react.default.createElement("strong", {
        className: classes.errorMessageWrapper
      }, /*#__PURE__*/_react.default.createElement(_Error.default, {
        className: classes.errorIcon
      }), /*#__PURE__*/_react.default.createElement("span", null, errorMessage));

      var readOnlyOnChange = function readOnlyOnChange() {// Do nothing
      };

      var renderedTextField = /*#__PURE__*/_react.default.createElement(_TextField.default, {
        variant: variant === "compact" ? "outlined" : variant === "inline" ? "standard" : variant,
        id: id,
        label: label,
        className: (0, _classnames.default)(className, "prmbl-textInput", classes.root, (0, _defineProperty2.default)({}, classes.error, error), classes[variant + "Wrapper"]),
        value: value !== null && value !== void 0 ? value : "",
        onChange: readOnly ? readOnlyOnChange : onChange,
        onFocus: onFocus,
        onKeyDown: onKeyDown,
        onKeyUp: onKeyUp,
        onClick: onClick,
        onBlur: onBlur,
        autoFocus: autoFocus,
        placeholder: placeholder,
        type: type,
        multiline: multiline,
        disabled: disabled,
        "aria-disabled": disabled,
        error: error,
        rows: rows,
        inputRef: function inputRef(input) {
          return _this.props.inputComponent = input;
        },
        rowsMax: rowsMax,
        required: required,
        fullWidth: fullWidth,
        InputLabelProps: appliedLabelProps,
        InputProps: appliedInputProps,
        FormHelperTextProps: {
          classes: {
            error: classes.error
          }
        },
        helperText: error && errorMessage ? renderedErrorMessage : helperText,
        style: style,
        ref: _this.formControlRef
      });

      return margin ? /*#__PURE__*/_react.default.createElement(_FormControl.default, {
        id: id,
        fullWidth: fullWidth,
        error: error
      }, renderedTextField) : renderedTextField;
    });
    _this.state = {
      didCopy: false
    };
    _this.formControlRef = /*#__PURE__*/_react.default.createRef();
    return _this;
  }

  return TextInput;
}(_react.Component);

exports.TextInput = TextInput;
(0, _defineProperty2.default)(TextInput, "propTypes", {
  /**
   * If `true`  the input will be focused during the first mount.
   */
  autoFocus: _propTypes.default.bool,

  /**
   * The value of the element.
   */
  value: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.number]),

  /**
   * If `true` the label, input, and helper text should be displayed in a disabled state.
   */
  disabled: _propTypes.default.bool,

  /**
   * 	If `true`, the input will indicate an error. And display the provided errorMessage
   */
  error: _propTypes.default.bool,

  /**
   * The message to display when `error` is `true`.
   */
  errorMessage: _propTypes.default.string,

  /**
   * Makes the input span the entire component's width
   */
  fullWidth: _propTypes.default.bool,

  /**
   * The contents of the `helper text`
   */
  helperText: _propTypes.default.node,

  /**
   * The html id
   */
  id: _propTypes.default.string,

  /**
   * The component used for the native input. Either a string to use a DOM element or a component.
   */
  inputComponent: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.func]),

  /**
   * Properties applied to the `input` element.
   */
  inputProps: _propTypes.default.object,

  /**
   * The contents of the `label`
   */
  label: _propTypes.default.node,

  /**
   * Additional props for the label
   */
  labelProps: _propTypes.default.shape({
    shrink: _propTypes.default.bool,
    classes: _propTypes.default.any
  }),

  /**
   * If `true` a textarea will be for the element
   */
  multiline: _propTypes.default.bool,

  /**
   * Callback fired when the value is changed.  `function(event: object) => void`
   *
   * `event` : The event source of the callback. You can pull out the new value via `event.target.value`
   */
  onChange: _propTypes.default.func,

  /**
   * Callback fired when the input element is focused.
   */
  onFocus: _propTypes.default.func,

  /**
   * Callback fired on key down event.
   */
  onKeyDown: _propTypes.default.func,

  /**
   * Callback fired on key up event.
   */
  onKeyUp: _propTypes.default.func,

  /**
   * Callback fired on click event.
   */
  onClick: _propTypes.default.func,

  /**
   * Callback fired on blur event.
   */
  onBlur: _propTypes.default.func,

  /**
   * The short hint displayed in the input before the user enters a value
   */
  placeholder: _propTypes.default.string,

  /**
   * If `true` the label will indicate that the input is required.
   */
  required: _propTypes.default.bool,

  /**
   * Number of rows to display when `multiline` is set to `true`. Rows takes priority over rowsMax
   */
  rows: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.number]),

  /**
   * Maximum number of rows that will be displayed when `multiline` is set to `true`.
   * See rows and rowsMax examples to see the clear difference between the two
   */
  rowsMax: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.number]),

  /**
   * The html5 input type
   */
  type: _propTypes.default.oneOf(["text", "number", "password", "email", "search", "url", "tel"]),

  /**
   * @ignore
   *
   * Utilized By:
   * CivicEngage, CP Platform
   */
  className: _propTypes.default.string,

  /**
   * How the input appears on page.
   */
  variant: _propTypes.default.oneOf(["standard", "outlined", "filled", "compact", "inline"]),

  /**
   * @ignore
   *
   * Utilizing this to style up the page don't want to expose this in the style guide.
   * Auto-populated by material-ui withStyles()
   */
  classes: _propTypes.default.object.isRequired,

  /**
   * Start `InputAdornment` for this component.
   */
  startAdornment: _propTypes.default.node,

  /**
   * End `InputAdornment` for this component. Overrideden by the `copy` prop
   */
  endAdornment: _propTypes.default.node,

  /**
   * The maximum length for the input value
   */
  maxLength: _propTypes.default.number,

  /**
   * Additional styles to render
   */
  style: _propTypes.default.object,

  /**
   * Passed on to the DOM element autocomplete prop
   */
  autoComplete: _propTypes.default.string,

  /**
   * Callback to set a ref to the DOM input component
   */
  inputRef: _propTypes.default.func,

  /**
   * If true, the endAdornment will be a copy button
   */
  copy: _propTypes.default.bool,

  /**
   * If false, the TextInput will not have a built-in margin
   */
  margin: _propTypes.default.bool,

  /**
   * When true, the item will not be editable, but the text will still be selectable
   */
  readOnly: _propTypes.default.bool
});
(0, _defineProperty2.default)(TextInput, "defaultProps", {
  className: "",
  variant: "outlined",
  margin: true
});

var _default = (0, _styles2.withStyles)(_styles.styles)(TextInput);

exports.default = _default;